/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Tooltip, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton} from '@ion/dls/src/components/buttons/IconButton';
import {useIsPhone} from '@ion/dls/src/hooks/useMedia';
import {JobStatusIcon} from '@ion/dls/src/icons/JobStatusIcon';
import {dlsAlt, dlsColor, dlsTypography} from '@ion/dls/src/theme/theme';

const tooltip = makeStyles(theme => ({
  arrow : {
    color : dlsColor('grey1')
  },
  tooltip : {
    ...dlsAlt('components', 'iconTooltip'),
    fontSize : '12px !important'
  }
}));

const useStyles = makeStyles(() => ({
  bulkActivityWrapper : {
    height         : '24px !important',
    padding        : '8px',
    display        : 'flex',
    justifyContent : 'center',
    alignItems     : 'center',
    cursor         : 'pointer',
    borderRadius   : '4px',
    '&:hover'      : {
      backgroundColor : dlsColor('paleBlue')
    }
  },
  bulkActivity : {
    ...dlsTypography('body1'),
    marginLeft : '4px',
    padding    : '0px !important',
    whiteSpace : 'nowrap'
  }
}));

export const JobStatusTooltip = function(props) {
  return <Tooltip arrow classes={tooltip()} {...props} />;
};

export interface JobStatusProps {
  onJobStatusClick: () => void;
  isSelected?: boolean;
}

/**
 * JobStatus component will provide the features like Bell icon with
 * notification count.
 *
 *  import JobStatus from '@ion/applications/src/JobStatus';
 *
 *  <JobStatus
 *       onJobStatusClick={onJobStatusClick}
 *       isSelected={isSelected} />
 *
 */
export const JobStatus = ({
  onJobStatusClick,
  isSelected
}: JobStatusProps) => {
  const classes = useStyles();
  const isPhone = useIsPhone();

  return (
    <JobStatusTooltip title={isPhone ? translate('common:jobStatusText'): ''}>
      <div className={!isPhone ? classes.bulkActivityWrapper : ''} onClick={onJobStatusClick}>
        <IconButton style={{padding: '8px'}}
          isSelected={isSelected}
          icon={<JobStatusIcon />} />
        {!isPhone &&
          <Typography className={classes.bulkActivity}
            onClick={onJobStatusClick}>
            {translate('common:jobStatusText')}
          </Typography>}
      </div>
    </JobStatusTooltip>
  );
};

export default JobStatus;
